import * as THREE from "three";
import { PointerLockControls } from "three/examples/jsm/controls/PointerLockControls.js";

/**
 * Base
 */

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

//Fog

const fog = new THREE.Fog("#262837", 2, 8);
scene.fog = fog;
/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader();

const doorColorTexture = textureLoader.load("./textures/door/color.jpg");
const doorAlphaTexture = textureLoader.load("./textures/door/alpha.jpg");
const doorAmbientOcclusionTexture = textureLoader.load(
  "./textures/door/ambientOcclusion.jpg"
);
const doorHeightTexture = textureLoader.load("./textures/door/height.jpg");
const doorNormalTexture = textureLoader.load("./textures/door/normal.jpg");
const doorMetalnessTexture = textureLoader.load(
  "./textures/door/metalness.jpg"
);

const wallColorTexture = textureLoader.load("./textures/bricks/color.jpg");
const wallAmbientOcclusionTexture = textureLoader.load(
  "./textures/bricks/ambientOcclusion.jpg"
);
const wallNormalTexture = textureLoader.load("./textures/bricks/normal.jpg");
const wallRoughnessTexture = textureLoader.load(
  "./textures/bricks/roughness.jpg"
);

const grassColorTexture = textureLoader.load("./textures/grass/color.jpg");
const grassAmbientOcclusionTexture = textureLoader.load(
  "./textures/grass/ambientOcclusion.jpg"
);
const grassNormalTexture = textureLoader.load("./textures/grass/normal.jpg");
const grassRoughnessTexture = textureLoader.load(
  "./textures/grass/roughness.jpg"
);

const grassTextureArray = [
  grassColorTexture,
  grassAmbientOcclusionTexture,
  grassNormalTexture,
];
grassTextureArray.forEach((texture) => {
  texture.repeat.set(8, 8);
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
});
/**
 * House
 */
const house = new THREE.Group();

scene.add(house);

//walls
const walls = new THREE.Mesh(
  new THREE.BoxGeometry(4, 3, 4),
  new THREE.MeshStandardMaterial({
    map: wallColorTexture,
    aoMap: wallAmbientOcclusionTexture,
    normalMap: wallNormalTexture,
    roughnessMap: wallRoughnessTexture,
  })
);
walls.position.y = 3 / 2;
walls.geometry.setAttribute(
  "uv2",
  new THREE.Float32BufferAttribute(walls.geometry.attributes.uv.array, 2)
);
house.add(walls);

const roof = new THREE.Mesh(
  new THREE.ConeGeometry(3.5, 1, 4),
  new THREE.MeshStandardMaterial({ color: "#b35f45" })
);
roof.position.y = 3.5;
roof.rotation.y = Math.PI / 4;
house.add(roof);

//door
const door = new THREE.Mesh(
  new THREE.PlaneGeometry(2.2, 2.2, 100, 100),
  new THREE.MeshStandardMaterial({
    map: doorColorTexture,
    transparent: true,
    alphaMap: doorAlphaTexture,
    aoMap: doorAmbientOcclusionTexture,
    displacementMap: doorHeightTexture,
    displacementScale: 0.03,
    normalMap: doorNormalTexture,
    metalnessMap: doorMetalnessTexture,
  })
);

door.geometry.setAttribute(
  "uv2",
  new THREE.Float32BufferAttribute(door.geometry.attributes.uv.array, 2)
);
door.position.set(0, 1, 2.001);
house.add(door);

//bushes
const bushGeometry = new THREE.SphereGeometry(1, 16, 16);
const bushMaterial = new THREE.MeshStandardMaterial({ color: 0x89c854 });

const bush1 = new THREE.Mesh(bushGeometry, bushMaterial);
bush1.scale.set(0.5, 0.5, 0.5);
bush1.position.set(0.8, 0.2, 2.2);

const bush2 = new THREE.Mesh(bushGeometry, bushMaterial);
bush2.scale.set(0.25, 0.25, 0.25);
bush2.position.set(1.4, 0.03, 2.1);

const bush3 = new THREE.Mesh(bushGeometry, bushMaterial);
bush3.scale.set(0.035, 0.035, 0.035);
bush3.position.set(-1, 0.05, 2.6);

const bush4 = new THREE.Mesh(bushGeometry, bushMaterial);
bush4.scale.set(0.4, 0.4, 0.4);
bush4.position.set(-0.8, 0.03, 2.2);

house.add(bush1, bush2, bush3, bush4);

//graves

const graves = new THREE.Group();
scene.add(graves);

const topShape = new THREE.Shape();
topShape.moveTo(-0.3, 0.4);
topShape.lineTo(-0.038, 0.48);
topShape.lineTo(0.038, 0.48);
topShape.lineTo(0.3, 0.4);

// Define the bottom shape of the tombstone
const bottomShape = new THREE.Shape();
bottomShape.moveTo(-0.3, -0.4);
bottomShape.lineTo(-0.3, 0.4);
bottomShape.lineTo(0.3, 0.4);
bottomShape.lineTo(0.3, -0.4);

// Create the 3D geometry for the tombstone by extruding the two shapes
const extrudeSettings = {
  depth: 0.2,
  bevelEnabled: false,
};
const graveGeometry = new THREE.ExtrudeGeometry(
  [topShape, bottomShape],
  extrudeSettings
);

// Create a mesh from the geometry
const graveMaterial = new THREE.MeshStandardMaterial({ color: 0xb2b6b1 });

// Add the mesh to the scene

// const graveGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.2);
// const graveMaterial = new THREE.MeshStandardMaterial({ color: 0xb2b6b1 });

for (let i = 0; i < 30; i++) {
  const angle = Math.random() * Math.PI * 2;
  const randomVariable = Math.random() * 4.7 + 5;
  const x = Math.sin(angle) * randomVariable;
  const z = Math.cos(angle) * randomVariable;
  const grave = new THREE.Mesh(graveGeometry, graveMaterial);
  grave.position.set(x, 0.34, z);
  grave.rotation.y = (Math.random() - 0.5) * 0.4;
  grave.rotation.z = (Math.random() - 0.5) * 0.4;
  grave.castShadow = true;
  graves.add(grave);
}

// const walls = new THREE.Mesh(new THREE.Boxbuff)
// Floor
const floor = new THREE.Mesh(
  new THREE.PlaneGeometry(20, 20),
  new THREE.MeshStandardMaterial({
    map: grassColorTexture,
    aoMap: grassAmbientOcclusionTexture,
    normalMap: grassNormalTexture,
    roughnessMap: grassRoughnessTexture,
  })
);
floor.rotation.x = -Math.PI * 0.5;
floor.geometry.setAttribute(
  "uv2",
  new THREE.Float32BufferAttribute(floor.geometry.attributes.uv.array, 2)
);
floor.position.y = 0;
scene.add(floor);

/**
 * Lights
 */

// Directional light
const moonLight = new THREE.DirectionalLight("#b9d5ff", 0.032);
moonLight.position.set(4, 5, -2);
scene.add(moonLight);

//Ghosts
const ghost1 = new THREE.PointLight("#EDE8D0", 2, 3);

const ghost2 = new THREE.PointLight("#F8FFFF", 2, 3);

const ghost3 = new THREE.PointLight("#E8ECFF", 2, 3);
scene.add(ghost1, ghost2, ghost3);
/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.03,
  100
);
document.addEventListener("keydown", () => {});

camera.position.x = -8.45;
camera.position.y = 1.5;
camera.position.z = -8.9;
camera.lookAt(0, 0, 0);
scene.add(camera);

//Flashlight

const flashLight = new THREE.SpotLight("pale yellow", 0.5, 0, 0.5);
camera.add(flashLight);
flashLight.target.position.z = -2;
camera.add(flashLight.target);

// Controls
const controls = new PointerLockControls(camera, document.body);
scene.add(controls.getObject());

document.addEventListener("click", () => {
  controls.lock();
});

let WPressed = false;
let EPressed = false;
let QPressed = false;
let SPressed = false;
let APressed = false;
let DPressed = false;
// add event listeners to track key presses
document.addEventListener("keydown", onKeyDown);
document.addEventListener("keyup", onKeyUp);
const introduction = document.getElementById("introduction");
console.log(introduction);
const button = document.querySelector(".playButton");
button.addEventListener("click", () => {
  let opacity = 1;
  const fadeOutAnimation = setInterval(() => {
    if (opacity < 0) {
      clearInterval(fadeOutAnimation);
      introduction.style.display = "none";
    } else {
      introduction.style.opacity = opacity;
      opacity -= 0.1;
    }
  }, 100);
});
console.log(button);
function onKeyDown(event) {
  switch (event.code) {
    case "KeyW":
      WPressed = true;
      break;
    case "KeyE":
      EPressed = true;
      break;
    case "KeyQ":
      QPressed = true;
      break;
    case "KeyS":
      SPressed = true;
      break;
    case "KeyA":
      APressed = true;
      break;
    case "KeyD":
      DPressed = true;
      break;
  }
}

function onKeyUp(event) {
  switch (event.code) {
    case "KeyW":
      WPressed = false;
      break;
    case "KeyE":
      EPressed = false;
      break;
    case "KeyQ":
      QPressed = false;
      break;
    case "KeyS":
      SPressed = false;
      break;
    case "KeyA":
      APressed = false;
      break;
    case "KeyD":
      DPressed = false;
      break;
  }
}

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.setClearColor("#262837");
renderer.shadowMap.enabled = true;

//Shadows
moonLight.castShadow = true;
moonLight.shadow.mapSize.height = 128;
moonLight.shadow.mapSize.width = 128;
flashLight.castShadow = true;
ghost1.castShadow = true;
ghost2.castShadow = true;
ghost3.castShadow = true;
floor.receiveShadow = true;
/**
 * Animate
 */
const clock = new THREE.Clock();
let randomNumber1 = 5 + Math.random() * 5;
let randomNumber2 = 5 + Math.random() * 5;
let randomNumber3 = 5 + Math.random() * 5;
const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const ghostAngle1 = (elapsedTime * randomNumber1) / 50;
  const ghostAngle2 = randomNumber2 + (elapsedTime * randomNumber2) / 100;
  const ghostAngle3 = Math.abs(
    randomNumber3 - (elapsedTime * randomNumber3) / 90
  );
  if (
    ghostAngle1 % (Math.PI * 2) >
      (randomNumber1 - 5) * ((2 * Math.PI) / 5) - 0.01 &&
    ghostAngle1 % (Math.PI * 2) < (randomNumber1 - 5) * ((2 * Math.PI) / 5)
  ) {
    ghost1.visible = false;
    randomNumber1 = 5 + Math.random() * 5;
    setTimeout(() => {
      ghost1.visible = true;
    }, 2000);
  }
  if (
    ghostAngle2 % (Math.PI * 2) >
      (randomNumber2 - 5) * ((2 * Math.PI) / 5) - 0.01 &&
    ghostAngle2 % (Math.PI * 2) < (randomNumber2 - 5) * ((2 * Math.PI) / 5)
  ) {
    ghost2.visible = false;
    randomNumber2 = 5 + Math.random() * 5;
    setTimeout(() => {
      ghost2.visible = true;
    }, 2000);
  }
  if (
    ghostAngle3 % (Math.PI * 2) >
      (randomNumber3 - 5) * ((2 * Math.PI) / 5) - 0.01 &&
    ghostAngle3 % (Math.PI * 2) < (randomNumber3 - 5) * ((2 * Math.PI) / 5)
  ) {
    ghost3.visible = false;
    randomNumber3 = 5 + Math.random() * 5;
    setTimeout(() => {
      ghost3.visible = true;
    }, 2000);
  }

  ghost1.position.set(
    (Math.sin(ghostAngle1) * randomNumber1 -
      (Math.sin(ghostAngle1 / 2) * randomNumber1) / 2) *
      (2 / 3),
    (Math.sin(ghostAngle1) * randomNumber1) / 2,
    (Math.cos(ghostAngle1) * randomNumber1 -
      (Math.cos(ghostAngle1) * randomNumber1) / 5) *
      (5 / 6)
  );
  ghost2.position.set(
    (Math.sin(ghostAngle2) * randomNumber2 +
      (Math.sin(ghostAngle2) * randomNumber2) / 4) *
      (4 / 5),
    (Math.sin(ghostAngle2) * randomNumber2) / 2,
    (Math.cos(ghostAngle2) * randomNumber2 +
      (Math.cos(ghostAngle2) * randomNumber2) / 2) *
      (2 / 3)
  );
  ghost3.position.set(
    Math.sin(ghostAngle3) * randomNumber3,
    (Math.sin(ghostAngle3) * randomNumber3) / 2,
    (Math.cos(ghostAngle3) * randomNumber3 -
      Math.cos(ghostAngle3) * randomNumber2) /
      2
  );
  //Controls
  if (
    WPressed &&
    !APressed &&
    !SPressed &&
    !DPressed &&
    !QPressed &&
    !EPressed
  ) {
    controls.moveForward(0.03);
  }
  // check if WPressed is true and EPressed is true, move forward and move right
  else if ((WPressed && EPressed) || EPressed || (WPressed && DPressed)) {
    controls.moveForward(0.03);
    controls.moveRight(0.03);
  }
  // check if WPressed is false and EPressed is true, move right
  else if (QPressed || (WPressed && QPressed) || (WPressed && APressed)) {
    controls.moveForward(0.03);
    controls.moveRight(-0.03);
  }
  // check if WPressed is false and EPressed is false, stop moving
  else if (SPressed && APressed) {
    controls.moveForward(-0.03);
    controls.moveRight(-0.03);
  } else if (SPressed && DPressed) {
    controls.moveForward(-0.03);
    controls.moveRight(0.03);
  } else if (SPressed) {
    controls.moveForward(-0.03);
  } else if (DPressed) {
    controls.moveRight(0.03);
  } else if (APressed) {
    controls.moveRight(-0.03);
  } else {
  }

  // Render
  renderer.render(scene, camera);
  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
